/*
 * MERRIA cart-drawer helpers (chỉ nạp khi cart_type = drawer).
 * 1) "Mua nhanh" [data-cart-drawer-open] → mở cart drawer (không rời trang).
 * 2) Quick-add bestseller [data-quick-add="<variantId>"] trong giỏ trống → thêm thẳng,
 *    refresh drawer bằng cơ chế renderContents của Dawn (cart/add.js + sections).
 * Dùng event delegation trên document → bền vững khi drawer re-render (innerHTML không chạy lại <script>).
 */
(function () {
  'use strict';

  // Idempotent: an toàn nếu nạp cả từ theme.liquid lẫn snippet cart-drawer (theme cũ thiếu tag).
  if (window.__merriaCartDrawerInit) return;
  window.__merriaCartDrawerInit = true;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('click', function (event) {
    // 1) Mở drawer từ nút "Mua nhanh".
    var opener = event.target.closest('[data-cart-drawer-open]');
    if (opener) {
      var drawer = getDrawer();
      if (drawer) {
        event.preventDefault();
        drawer.open(opener);
      }
      return;
    }

    // 2) Quick-add bestseller.
    var qa = event.target.closest('[data-quick-add]');
    if (qa) {
      event.preventDefault();
      quickAdd(qa);
      return;
    }

    // 3) "Đổi size": mở/đóng picker variant inline.
    var sizeEdit = event.target.closest('[data-size-edit]');
    if (sizeEdit) {
      event.preventDefault();
      var box = sizeEdit.closest('.cart-item__sizebox');
      var picker = box && box.querySelector('.cart-item__size-picker');
      if (picker) {
        var willOpen = picker.hasAttribute('hidden');
        if (willOpen) {
          picker.removeAttribute('hidden');
          sizeEdit.setAttribute('aria-expanded', 'true');
        } else {
          picker.setAttribute('hidden', '');
          sizeEdit.setAttribute('aria-expanded', 'false');
        }
      }
      return;
    }

    // 4) "Đổi size": chọn variant → swap trong giỏ.
    var sizeSwap = event.target.closest('[data-size-swap]');
    if (sizeSwap) {
      event.preventDefault();
      swapSize(sizeSwap);
    }
  });

  // Đổi variant của 1 dòng: thêm variant mới (giữ qty) rồi bỏ dòng cũ, render lại drawer.
  function swapSize(button) {
    if (
      button.disabled ||
      button.classList.contains('is-current') ||
      button.classList.contains('is-loading')
    ) {
      return;
    }
    var newId = button.getAttribute('data-size-swap');
    var fromLine = parseInt(button.getAttribute('data-from-line') || '0', 10);
    var qty = parseInt(button.getAttribute('data-qty') || '1', 10) || 1;
    if (!newId || !fromLine) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var drawer = getDrawer();
    var sections = drawer
      ? drawer.getSectionsToRender().map(function (s) {
          return s.section || s.id;
        })
      : ['cart-drawer', 'cart-icon-bubble'];

    // Đổi variant = bỏ dòng cũ (theo LINE index, đúng cách Dawn) → thêm variant mới (giữ qty).
    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: fromLine, quantity: 0 }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (removed) {
        if (removed && removed.status) {
          throw new Error(removed.description || removed.message || 'remove failed');
        }
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(newId), quantity: qty }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (drawer && data && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (error) {
        console.warn('[merria] size swap failed:', error);
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  function quickAdd(button) {
    var variantId = button.getAttribute('data-quick-add');
    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var drawer = getDrawer();
    var sections = drawer
      ? drawer.getSectionsToRender().map(function (s) {
          return s.section || s.id;
        })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          // Lỗi (hết hàng / variant sai) — log, không phá UI.
          console.warn('[merria] quick-add error:', data.message || data.description);
          return;
        }
        if (drawer && data.sections) {
          // Dawn's CartDrawer.renderContents() chỉ bỏ is-empty trên .drawer__inner (node bị
          // ghi đè ngay bởi innerHTML) — phải tự bỏ trên element <cart-drawer> để header +
          // padding của giỏ-có-hàng hiện đúng (giống product-form.js).
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else if (drawer) {
          drawer.open();
        } else {
          window.location.href = root() + 'cart';
        }
      })
      .catch(function (error) {
        console.warn('[merria] quick-add failed:', error);
        window.location.href = root() + 'cart';
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }
})();
